import React from 'react';

const Terms = () => {
  return (
    <>
      <section className="hero" style={{ paddingBottom: '40px' }}>
        <div className="container hero-content fade-up">
          <h1 className="hero-title" style={{ fontSize: '2.25rem' }}>
            Terms of Use
          </h1>
          <p className="hero-subtitle" style={{ fontSize: '1rem' }}>
            Last Updated: March 3, 2026
          </p>
        </div>
      </section>

      <section style={{ paddingTop: 0 }}>
        <div className="container-sm">
          <div style={{ fontSize: '0.95rem', color: 'var(--text)', lineHeight: 1.8 }}>

            <p style={{ fontWeight: 600, marginBottom: '24px' }}>
              PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING THIS WEBSITE. BY ACCESSING OR USING
              THIS WEBSITE, YOU ACKNOWLEDGE AND AGREE THAT YOU HAVE READ, UNDERSTAND, AND AGREE TO BE
              BOUND BY THESE TERMS OF USE AND ANY OTHER APPLICABLE LAWS. IF THESE TERMS OF USE ARE NOT
              ACCEPTABLE IN FULL, YOU MUST IMMEDIATELY TERMINATE YOUR USE OF THIS WEBSITE.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              1. Definitions
            </h2>
            <ul style={{ paddingLeft: '24px', margin: '12px 0' }}>
              <li>"Company," "we," "us," or "our" means Knock Knock LLC.</li>
              <li>"kNine" refers to the kNine product, platform, services, and website operated by Knock Knock LLC.</li>
              <li>"Website" means knine.ai and any pages, subdomains, and related web properties operated by the Company that link to these Terms.</li>
              <li>"Services" means any features, tools, software, AI-driven functionality, dashboards, data outputs, subscriptions, trials, and related offerings provided by or through kNine.</li>
              <li>"Content" means all content made available on the Website or through the Services, including text, software, scripts, code, designs, graphics, photos, sounds, music, videos, applications, interactive features, data outputs, and all other materials.</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              2. Intellectual Property
            </h2>
            <p>
              "Knock Knock" and "kNine" are trademarks of and owned by Knock Knock LLC (the "Company"). All
              third-party trademarks and other third-party intellectual property rights remain the property of
              their respective owners.
            </p>
            <p>
              All Content on the Website and Services is a collective work under the United States and other
              copyright laws and is the proprietary property of Knock Knock LLC; all rights reserved. By using
              the Website or Services, you acknowledge Knock Knock LLC's ownership of and interest in its
              intellectual property and agree not to challenge the validity or enforceability thereof.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              3. Changes to the Website and These Terms
            </h2>
            <p>
              The Website, Services, and these Terms of Use may be changed by the Company and such changes will
              be effective when they are posted. Please review the Website periodically for changes. Continued
              use of the Website or Services following any changes constitutes your acceptance of such changes.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              4. Availability and Updates
            </h2>
            <p>
              The Company may alter, suspend, or discontinue this Website or Services at any time and for any
              reason or no reason, without notice. The Website or Services may be unavailable from time to time
              due to maintenance or malfunction of computer or network equipment or other reasons. The Company
              may periodically add or update information and materials on this Website without notice.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              5. Privacy
            </h2>
            <p>
              Our Privacy Policy, located on the Website and/or at knockknock.ai/privacy-policy (or another URL
              designated on knine.ai), is incorporated into these Terms of Use and describes the collection and
              use of information on this Website and through the Services.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              6. Eligibility to Use
            </h2>
            <p>
              This Website and Services are intended solely for users who are thirteen (13) years of age or older
              and it is a violation of these Terms of Use for anyone under 13 years of age to access the Website
              or submit any user information. We will not knowingly collect personally identifiable information
              from persons under 13. You represent and warrant that you are 13 years or older. You agree to
              provide accurate and current information about yourself in all forms on the Website. If you are
              under 13, you agree to immediately stop accessing the Website.
            </p>
            <p>
              The sale of any products or services offered via this Website, or those of its affiliates, are not
              directed to persons under the age of 18. If you are purchasing any products or services via this
              Website, you represent that you are at least 18 years of age.
            </p>
            <p>
              This Website and Services are intended solely for users in the United States, specifically individuals
              or companies that reside and/or operate within the United States, except for the State of California.
              We do not offer our Services to any individuals or entities located within the State of California or
              to any customer located and/or operating outside the United States. If you are a citizen of the
              European Union, please do not use our Services or Website or submit any data to our Website, as it
              is not intended for your use.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              7. Website Use Restrictions
            </h2>
            <p>
              You may use the Content only for your own use to view on the Website or to purchase products or
              services sold via the Website. You agree not to change or delete any ownership notices from materials
              downloaded or printed from the Website. You agree not to modify, copy, translate, broadcast, perform,
              display, distribute, frame, reproduce, republish, download, display, post, transmit or sell any
              intellectual property or Content appearing on the Website without the Company's prior written consent.
              You agree not to use any data mining, robots, scraping or similar data gathering methods. Nothing in
              these Terms of Use shall be interpreted as granting any license of intellectual property rights to you.
            </p>
            <p>While using the Website or Services, you agree not to do any of the following:</p>
            <ul style={{ paddingLeft: '24px', margin: '12px 0' }}>
              <li>harass, stalk or otherwise abuse another user;</li>
              <li>collect personal data about other users for commercial or unlawful purposes;</li>
              <li>transmit or otherwise make available any content that is false, harmful, threatening, abusive, tortious, defamatory, libelous, disparaging (including disparaging of the Website or Services), vulgar, obscene, pornographic or that promotes violence, racial hatred, terrorism or illegal acts, or is otherwise objectionable (as determined by us in our sole discretion);</li>
              <li>transmit or otherwise make available any content that is unlawful or infringes, violates or misappropriates any patent, trademark, trade identity right, trade secret, publicity right, privacy right, copyright or any other intellectual property or any other rights of any third party;</li>
              <li>transmit or otherwise make available through the Website any personal advertising, junk mail, spam, chain letters, pyramid schemes or offer for sale of any products or services, except in areas specifically designated for such purposes;</li>
              <li>attempt to gain unauthorized access to our computer system or to any other user's computer system;</li>
              <li>impersonate any person or entity, or otherwise disguise the origin of any content transmitted through the Website or to us, including forging any TCP/IP packet header or any part of the header information in any transmission to the Website for any reason;</li>
              <li>use automated means, including scripts, spiders, robots, crawlers, data mining tools, etc., to download or upload data to or from the Website or Services;</li>
              <li>upload or transmit viruses, Trojan horses or other harmful, disruptive or destructive files or post material that interferes with any third party's uninterrupted use and enjoyment of the Website;</li>
              <li>violate any applicable local, state, federal or international law, rule or regulation; or</li>
              <li>engage in any activity that disrupts, diminishes the quality of, interferes with the performance of, or impairs the functionality of the Website or Services.</li>
            </ul>
            <p>
              We reserve the right, without notice and in our sole discretion, to revoke your right to use the
              Website and/or Services and block or prevent your future access.
            </p>
            <p>
              We also reserve the right to fully cooperate with any law enforcement authorities or court order
              requesting or directing us to disclose any information as necessary to satisfy any applicable law,
              regulation, legal process, or governmental request.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              8. kNine Services and AI/Automated Outputs
            </h2>
            <p>
              The kNine Services may generate outputs, recommendations, contact/company information, candidate
              sourcing information, or other data insights using automated processing and/or artificial intelligence
              technologies.
            </p>
            <p>You understand and agree that:</p>
            <ul style={{ paddingLeft: '24px', margin: '12px 0' }}>
              <li>outputs are provided for informational purposes and should be independently verified before relying on them for business decisions;</li>
              <li>the Company does not guarantee the completeness, accuracy, or suitability of any output for a particular purpose; and</li>
              <li>you are responsible for how you use any outputs, including compliance with all applicable laws and third-party terms.</li>
            </ul>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              9. Comments and User Generated Content
            </h2>
            <p>
              By submitting comments and/or other content to the Website or Services, you are granting the Company
              a royalty-free, perpetual, irrevocable, non-exclusive right and license to use, reproduce, modify,
              adapt, publish, translate, distribute, transmit, publicly display, publicly perform, sublicense,
              create derivative works from, transfer, and sell your submissions (in whole or part) worldwide and/or
              to incorporate your submissions in other works in any form, media, or technology whether now known or
              later developed.
            </p>
            <p>
              We reserve the right, in our sole discretion, to edit, refuse to publish or remove any user-generated
              content that we believe may be prohibited or inappropriate.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              10. Feedback
            </h2>
            <p>
              If you provide the Company with any suggestions, comments or other feedback relating to any aspect
              of the Website or Services ("Feedback"), the Company may use such Feedback in the Website, Services,
              other websites, marketing, or promotional materials. Accordingly, you agree that: (a) the Company is
              not subject to any confidentiality obligations with respect to the Feedback; (b) the Feedback is not
              confidential or proprietary information of you or any third party and you have all necessary rights
              to disclose it; (c) the Company may freely use, reproduce, publicize, license, distribute, and
              otherwise commercialize Feedback; and (d) you are not entitled to compensation or reimbursement of
              any kind for the Feedback.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              11. Links to Other Websites
            </h2>
            <p>
              The Website may contain links to websites, applications, products or services operated by other
              companies ("Third Party Websites"). The Company does not endorse, monitor or have any control over
              these Third Party Websites, which have separate terms of use and privacy policies. The Company is
              not responsible for the content, advertising, products, or policies of Third Party Websites and you
              access such Third Party Websites at your own risk.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              12. Links From Other Websites
            </h2>
            <p>
              Other sites may link to this Website only through a plain-text link or provided graphics link.
              Permission must be granted by us for any other type of link. To seek permission, you may send an
              email to <a href="mailto:support@knockknock.ai">support@knockknock.ai</a>. We reserve the right to
              rescind permission and require termination of any link to this Website at our discretion.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              13. Copyright Infringement Complaints
            </h2>
            <p>
              If you believe that your work has been improperly copied and posted on this Website such that it
              constitutes infringement, please provide the following: (1) name, address, telephone number, email
              address and an electronic or physical signature of the copyright owner or authorized agent;
              (2) description of the copyrighted work claimed infringed; (3) location on the Website of the
              allegedly infringing material, including relevant URLs; (4) statement of good faith belief that use
              is not authorized; and (5) statement under penalty of perjury that the information is accurate and
              that you are the copyright owner or authorized agent.
            </p>
            <p>Send notices to:</p>
            <p style={{ paddingLeft: '24px', fontStyle: 'italic' }}>
              Knock Knock LLC<br />
              ATTN: Legal Department<br />
              11370 Butternut Road<br />
              Chardon, Ohio 44024<br />
              United States
            </p>
            <p>
              We suggest you consult a legal advisor before submitting a notice, as there may be penalties for
              false claims.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              14. Disclaimers
            </h2>
            <p>
              The Content on this Website and through the Services is for informational purposes only. The Content
              is not intended to be a substitute for professional advice and does not constitute legal, medical, or
              other professional advice. Reliance on any information provided is solely at your own risk.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              15. Warranty Disclaimer
            </h2>
            <p>
              The Website and Services, including Content, are provided "AS IS" and without warranties of any kind.
              To the fullest extent permitted by law, the Company disclaims all warranties, express or implied,
              including implied warranties of title, merchantability, fitness for a particular purpose, and
              non-infringement. The Company does not promise specific results from use of the Website or Services.
            </p>
            <p>
              You understand and agree that you download or otherwise obtain Content at your own risk and you will
              be solely responsible for your use and any damage to devices or systems or loss of data.
            </p>
            <p>
              Some states do not permit limitations or exclusions on warranties, so the above may not apply to you.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              16. Limitation of Liability
            </h2>
            <p style={{ fontWeight: 600 }}>
              NEITHER THE COMPANY NOR ANY OF ITS PARTNERS OR AFFILIATES SHALL BE LIABLE FOR ANY DIRECT, SPECIAL,
              INCIDENTAL, INDIRECT OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS OR LOST DATA, THAT RESULT
              FROM THE USE OF, OR THE INABILITY TO USE, THIS WEBSITE OR SERVICES, EVEN IF ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES.
            </p>
            <p style={{ fontWeight: 600 }}>
              YOU ASSUME TOTAL RESPONSIBILITY FOR YOUR USE OF THE WEBSITE AND SERVICES. YOUR ONLY REMEDY IS TO
              STOP USING THEM. IF THE COMPANY IS FOUND LIABLE FOR ANY DAMAGE CONNECTED WITH YOUR USE, THE
              COMPANY'S LIABILITY SHALL NOT EXCEED US$100.00.
            </p>
            <p style={{ fontWeight: 600 }}>
              APPLICABLE LAW MAY NOT ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY, SO THE ABOVE MAY NOT
              APPLY TO YOU.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              17. Indemnification
            </h2>
            <p>
              You agree to indemnify, defend, and hold harmless the Company, its affiliates, officers, directors,
              employees, agents, licensors and suppliers from and against all claims, losses, liabilities, expenses,
              damages and costs (including attorneys' fees) arising from or relating to your use of Content, your
              use of the Website or Services, your conduct, or any violation of these Terms or rights of any third party.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              18. Your Responsibility During a Claim
            </h2>
            <p>
              You agree to cooperate and assist us in defending any claim brought by a third party arising from your
              breach of these Terms and you will allow us to handle any such claim.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              19. No Class Actions
            </h2>
            <p>
              You agree that claims or disputes shall be resolved in your individual capacity and not as a plaintiff
              or class member in any class, consolidated, or representative proceeding, to the extent permitted by law.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              20. Governing Law; Jurisdiction; Disputes
            </h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the State of Ohio, United
              States, without regard to conflict of law provisions. You agree to submit to the jurisdiction of, and
              agree that venue is proper in, the courts in Geauga County, Ohio.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              21. Severability
            </h2>
            <p>
              If any provision is held invalid, unlawful, void or unenforceable, that provision is severable and the
              remaining provisions remain valid and enforceable. Failure to enforce any right or provision is not a waiver.
            </p>
            <p>
              These Terms, including the Privacy Policy and any Terms of Service posted for paid Services, constitute
              the entire agreement regarding use of the Website and/or Services and supersede prior agreements
              regarding the Website and/or Services.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              22. Acceptance of Terms
            </h2>
            <p>
              You acknowledge that you have read this agreement, understand it, and agree to be bound by its terms
              and conditions.
            </p>

            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--text-dark)', marginTop: '32px', marginBottom: '12px' }}>
              23. Contact
            </h2>
            <p>
              If you have questions about these Terms, contact us at{' '}
              <a href="mailto:support@knockknock.ai">support@knockknock.ai</a>.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
